import React, { useState } from 'react';
import { Container, ThisCard } from './styles';

import IconPortal from '~/assets/icones/IconNivel.svg';

function CustomBodyContent({ data }) {
  const [linhaAtiva, setLinhaAtiva] = useState([]);

  return (
    <Container>
      {data?.map((thisData, i) => (
        <ThisCard
          className={linhaAtiva === thisData?.id ? 'card-item ativo' : 'card-item'}
          {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
          key={thisData?.id || i}
          id={thisData?.id || i}
          index={i}
          ativo={linhaAtiva === thisData?.id ? true : false}
          cor={thisData?.cor}
        >
          <div className="card-body">
            <div className="card-text">
              <p className="descricao">#{thisData?.codigo}</p>
              <p className="titulo">{thisData?.titulo}</p>
              {thisData?.descricao && <p className="descricao-texto">{thisData?.descricao}</p>}
            </div>
          </div>
        </ThisCard>
      ))}
    </Container>
  );
}

export default CustomBodyContent;
